export const common = {
  common: {
    cancel: 'Abbrechen',
    proceed: 'ÄNDERUNGEN SPEICHERN',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Bearbeiten',
    restore: 'Restore',
    back: 'zurück',
    submit: 'Submit',
    continue: 'Continue',
    save: 'Save',
    done: 'Done',
    home: 'Home',
    noData: 'No data.',
    confirm: 'Confirm',
    more: 'more',
    close: 'Close',
    loading: 'Loading',
    menu: 'Menu',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    create: 'Create',
    success: 'Erfolgreich',
    error: 'Nicht erfolgreich',
    warning: 'Achtung',
    move: 'Move',
    update: 'Umbennen',
    next: 'Weiter',
    rejectAddress:'Adresse bestätigen',
    compareDetails: 'Alle Details vergleichen',
    hideDetails: 'Alle Details verbergen',
    net: 'Netto',
    showAllProducts: 'Alle Produkte anzeigen',
    homepage: 'Startseite',
    discount: 'gespart',
    customerNumber: "Kundennummer",
    extraInfo:"Dies ist Ihr persönliches Wehrfritz Profil, hier finden Sie alle wichtigen Informationen.",
    salutation: {
      female: 'Frau',
      male: 'Herr',
      diverse: 'Divers',
    },
    viewAll: 'Alle Anzeigen',
    overviewPage: 'Übersichtsseite',
    mainNavigation: 'Hauptnavigation'
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} result for {{query}}',
      title_plural: '{{count}} results for {{query}}',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_plural: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_plural: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'All products',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Loading...',
  },
  navigation: {
    shopAll: 'Shop all {{ navNode}} >',
  },
  searchBox: {
    placeholder: 'Search here...',
    ariaLabelInput: 'Search here...',
    ariaLabelSuggestions: 'typing suggestions',
    ariaLabelProducts: 'product results',
    initialDescription:
      'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
    suggestionsResult: '{{ count }} suggestion and ',
    suggestionsResult_plural: '{{ count }} suggestions and ',
    productsResult: '{{ count }} product is available.',
    productsResult_plural: '{{ count }} products are available.',
    resetLabel: 'Reset Search',
    help: {
      insufficientChars: 'Please type more characters',
      noMatch: 'We could not find any results',
      exactMatch: '{{ term }}',
      empty: 'Ask us anything',
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Order Number',
    rma: 'Return Number',
    replenishmentNumber: 'Replenishment Number',
    nextOrderDate: 'Next Order Date',
  },
  httpHandlers: {
    badGateway: 'A server error occurred. Please try again later.',
    badRequestPleaseLoginAgain:
      'Das hat leider nicht funktioniert. Bitte prüfen Sie, ob Sie die richtige E-Mail-Adresse und das richtige Passwort verwenden.',
    badRequestOldPasswordIncorrect: 'Old password incorrect.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} email already exist. Please checkout with a different email to register using a guest account.',
    conflict: 'Already exists.',
    forbidden:
      'You are not authorized to perform this action. Please contact your administrator if you think this is a mistake.',
    gatewayTimeout: 'Server antwortet nicht, bitte versuchen Sie es später erneut.',
    internalServerError:
      'Es ist ein interner Serverfehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
    sessionExpired: 'Your session has expired. Please login again.',
    unknownError: 'An unknown error occurred',
    unauthorized: {
      common: 'An unknown authorization error occured',
      invalid_client: 'Bad client credentials',
    },
    validationErrors: {
      missing: {
        card_cardType: 'The selected credit card is not supported. Please select another.',
        card_accountNumber: 'The credit card number entered is not valid.',
        card_cvNumber: 'The security code entered is not valid.',
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        card_expirationYear: 'The credit card expiration date entered is not valid.',
        billTo_firstName: 'The first name entered is not valid.',
        billTo_lastName: 'The last name entered is not valid.',
        billTo_street1: 'The address entered is not valid.',
        billTo_street2: 'The address entered is not valid.',
        billTo_city: 'The city entered is not valid for this credit card.',
        billTo_state: 'The state/province entered is not valid for this credit card.',
        billTo_country: 'The country/region entered is not valid for this credit card.',
        billTo_postalCode: 'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Missing country/region',
        },
      },
      invalid: {
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        firstName: 'First Name entered is not valid.',
        lastName: 'Last Name entered is not valid.',
        password: 'Password entered is not valid.',
        uid: 'Email is not valid.',
        code: 'Code is not valid.',
        email: 'Email is not valid.',
      },
    },
    cartNotFound: 'Cart not found.',
    invalidCodeProvided: 'Invalid code provided.',
  },
  skipLink: {
    skipTo: 'Skip to',
    labels: {
      header: 'Header',
      main: 'Zum Seiteninhalt springen',
      footer: 'Footer',
      productFacets: 'Product Facets',
      productList: 'Product List',
    },
  },
  formErrors: {
    globalMessage: 'The form you are trying to submit contains errors.',
    required: 'Pflichtfeld',
    maxLength40: 'Das Feld ist begrenzt auf 40 Zeichen.',
    maxLength100: 'Das Feld ist begrenzt auf 100 Zeichen.',
    maxLength10: 'Das Feld ist begrenzt auf 10 Zeichen.',
    invalidName:
      'Bitte überprüfe, ob dein eingegebener Name keine Zahlen oder untypische Symbole (%&$...) enthält.',
    cxInvalidEmail: 'Dies ist kein gültiges E-Mail-Format',
    cxInvalidPassword: 'This is not a valid password format',
    cxPasswordsMustMatch: 'Password fields must match',
    cxEmailsMustMatch: 'Email fields must match',
    cxStarRatingEmpty: 'Rating field is required',
    cxNoSelectedItemToCancel: 'Select at least one item',
    cxNegativeAmount: 'Amount must be equal or greater than zero',
    cxContainsSpecialCharacters: 'Field cannot contain special characters',
    cxInvalidVatIdFormat: 'Bitte im Format {{format}} angeben',
    birthDateNotEligible:
      'Bitte überprüfen Sie Ihr Geburtsdatum. Wenn Sie nicht volljährig sind, können Sie nicht bestellen.',
    birthDateNotValid: 'Ungültiges Datum',
    invalidMonth: 'Ungültiger Monat',
    invalidYear: 'Ungültiges Jahr',
    numbersAllowedOnly: 'Nur Zahlen sind erlaubt',
    invalidPostalCode: 'Bitte überprüfe, ob die eingegebene Postleitzahl korrekt ist. Format: {{format}}',
    date: {
      required: 'This field is required',
      min: 'Date cannot be before {{min}}',
      max: 'Date cannot be after {{max}}',
      pattern: 'Use dateformat yyyy-mm-dd',
      invalid: 'Use a valid date',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'Failed to load the script.',
    refreshThePage: 'Please refresh the page.',
  },
};
